export const areaLabelMap = {
  1: 'アジア',
  2: '東南アジア',
  3: '南アジア',
  4: '中東',
  5: 'ヨーロッパ',
  6: 'オセアニア・太平洋',
  7: '北アメリカ',
  8: '中南米',
  9: 'アフリカ'
}

export const areaDescriptionCountries = {
  1: '韓国・中国・台湾・香港',
  2: 'シンガポール・ベトナム・インドネシア・フィリピン・タイ',
  3: 'インド・スリランカ・ネパール・バングラデシュ',
  4: 'イラン・トルコ・カタール・サウジアラビア',
  5: 'フランス・イギリス・ドイツ・イタリア・スペイン',
  6: 'オーストラリア・ハワイ・ニュージーランド・グアム・ニューカレドニア',
  7: 'アメリカ・カナダ',
  8: 'メキシコ・ブラジル・アルゼンチン・ペルー・ベネズエラ・コロンビア',
  9: 'エジプト・モロッコ・エチオピア・マダガスカル・ケニア'
}
